import React from "react";
import { UserContext } from "./UserProvider";
import type { UserContextType } from "./UserProvider";

export const useUserContext = (): UserContextType =>
  React.useContext(UserContext);
